import { useState } from "react";
import { Send } from "lucide-react";
import { submitContactForm } from "@/lib/contentApi";

const initialForm = {
  name: "",
  email: "",
  company: "",
  phone: "",
  interest: "",
  message: "",
};

export function ContactForm({ content }) {
  const [form, setForm] = useState(initialForm);
  const [status, setStatus] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const update = (field, value) => setForm((previous) => ({ ...previous, [field]: value }));

  const handleSubmit = async (event) => {
    event.preventDefault();
    setSubmitting(true);
    setStatus(content?.sendingLabel || "Sending…");
    try {
      const result = await submitContactForm(form);
      setForm(initialForm);
      setStatus(result.email_status === "emailed" ? (content?.successLabel || "Message sent. Thank you.") : (content?.savedLabel || result.message));
    } catch (error) {
      setStatus(error.response?.data?.detail || content?.errorLabel || "Could not send message. Please try again.");
    } finally {
      setSubmitting(false);
    }
  };

  const labels = content?.fields || {};
  return (
    <section id="inquiry" className="section contact-form-section" data-testid="contact-form-section">
      <div className="section-heading wide">
        <p className="overline" data-testid="contact-form-overline">{content?.overline}</p>
        <h2 data-testid="contact-form-title">{content?.title}</h2>
        <p data-testid="contact-form-description">{content?.description}</p>
      </div>

      <form className="contact-form-grid" onSubmit={handleSubmit} data-testid="contact-form">
        <label data-testid="contact-name-field">
          <span>{labels.name}</span>
          <input required minLength={2} value={form.name} onChange={(event) => update("name", event.target.value)} data-testid="contact-name-input" />
        </label>
        <label data-testid="contact-email-field">
          <span>{labels.email}</span>
          <input required type="email" value={form.email} onChange={(event) => update("email", event.target.value)} data-testid="contact-email-input" />
        </label>
        <label data-testid="contact-company-field">
          <span>{labels.company}</span>
          <input value={form.company} onChange={(event) => update("company", event.target.value)} data-testid="contact-company-input" />
        </label>
        <label data-testid="contact-phone-field">
          <span>{labels.phone}</span>
          <input value={form.phone} onChange={(event) => update("phone", event.target.value)} data-testid="contact-phone-input" />
        </label>
        <label className="wide" data-testid="contact-interest-field">
          <span>{labels.interest}</span>
          <input value={form.interest} onChange={(event) => update("interest", event.target.value)} data-testid="contact-interest-input" />
        </label>
        <label className="wide" data-testid="contact-message-field">
          <span>{labels.message}</span>
          <textarea required minLength={10} rows={6} value={form.message} onChange={(event) => update("message", event.target.value)} data-testid="contact-message-textarea" />
        </label>
        <div className="contact-form-footer wide">
          <button type="submit" className="btn btn-primary" disabled={submitting} data-testid="contact-submit-button">
            <Send size={16} aria-hidden="true" /> {submitting ? content?.sendingLabel : content?.submitLabel}
          </button>
          {status ? <p role="status" data-testid="contact-form-status">{status}</p> : null}
        </div>
      </form>
    </section>
  );
}